import styled, { createGlobalStyle } from "styled-components";

const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  tv: "1920px",
  desktop: "2560px",
  uhd: "3840px",
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileL})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(min-width: 769px)`,
  laptopMax: `(max-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  tv: `(min-width: ${size.tv}) and (max-width: ${size.desktop})`,
  tvL: `(min-width: ${size.desktop}) and (max-width: ${size.uhd})`,
  uhd: `(min-width: ${size.uhd})`,
};

export const GlobalStyle = createGlobalStyle`

:root { 
    --mainBgColor: #FFFFFF;
    --secondaryBgColor: #001666;
    --mainTextColor: #838E9B;
    --mainTextColorOpacity: #838E9BAA;
    --secondaryTextColor: #001666;
    --grey: #838E9B;
    --opacityGrey: #BEC2CA;
    --lightBlue: #4f8bd1;
    --blue: #4771c4;
    --darkBlue: #4058b2;
    --lightPurple: #7f83c3;
    --darkPurple: #6c40a2;
    --lightPink: #f4659a;
    --darkPink: #84306c;
    --lightGreen: #a8df9c;
    --green: #67c9a3;
}

html, body, div, ul ,li, figure, figcaption, h1, h2, h3, h4, h5, h6, p, a, form, input, button, main, section, nav, header, footer {
    box-sizing: border-box;
    text-decoration: none;
    padding: 0;
    margin: 0;
}

body{
    background-color: var(--mainBgColor);
    font-family:'Roboto', 'Kanit', sans-serif;
}

`;

export const ContainerInitial = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  height: 100vh;

  @media ${device.mobileS} and ${device.mobileM} {
    width: 100%;
    height: 70vh;
  }

  @media ${device.mobileL} and ${device.tablet} {
    width: 100%;
    height: 70vh;
  }

  @media ${device.laptop} and ${device.laptopMax} {
    width: 100%;
    right: auto;
    top: auto;
    bottom: 0;
    height: 60vh;
  }
`;
